import { render, staticRenderFns } from "./2020FeatureIcon.vue?vue&type=template&id=6a4075bc&scoped=true"
import script from "./2020FeatureIcon.vue?vue&type=script&lang=js"
export * from "./2020FeatureIcon.vue?vue&type=script&lang=js"
import style0 from "./2020FeatureIcon.vue?vue&type=style&index=0&id=6a4075bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4075bc",
  null
  
)

export default component.exports